// extracted by mini-css-extract-plugin
export default {"wrapper":"primary_wrapper__-N7KY","main":"primary_main__Ltsg7","bottom":"primary_bottom__Efkat","campaign_card":"primary_campaign_card__flu+b"};